export enum EnterprizePosition {
  CHAIRMAN_OF_THE_BOARD = "CHAIRMAN_OF_THE_BOARD",
  CHAIRMAN_OF_THE_MEMBERS_COUNCIL = "CHAIRMAN_OF_THE_MEMBERS_COUNCIL",
  DIRECTOR_GENERAL = "DIRECTOR_GENERAL",
  DIRECTOR = "DIRECTOR",
}
